/*
 * Author: Roger
 * File Created: Thursday, 24-08-29 05:18 pm
 * Last Modified: Thursday, 24-08-29 05:45 pm, by Roger
 */

const Avatar = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" fill="none" data-sentry-element="svg" data-sentry-component="Avatar" data-sentry-source-file="index.tsx">
      <g clipPath="url(#clip0_35_231)" data-sentry-element="g" data-sentry-source-file="index.tsx">
        <rect width="44" height="44" fill="#252837" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        <path fillRule="evenodd" clipRule="evenodd" d="M22 27.2222C26.7558 27.2222 30.6111 23.3669 30.6111 18.6111C30.6111 13.8553 26.7558 10 22 10C17.2442 10 13.3889 13.8553 13.3889 18.6111C13.3889 23.3669 17.2442 27.2222 22 27.2222ZM16.5 30.6667C10.9772 30.6667 6.5 35.1438 6.5 40.6667V49.6111H37.5V40.6667C37.5 35.1438 33.0228 30.6667 27.5 30.6667H16.5Z" fill="#4F5867" data-sentry-element="path" data-sentry-source-file="index.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="index.tsx">
        <clipPath id="clip0_35_231" data-sentry-element="clipPath" data-sentry-source-file="index.tsx">
          <rect width="44" height="44" fill="white" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        </clipPath>
      </defs>
    </svg>;
};
export default Avatar;